const auth = require('./auth');
const entity = require('./entity');


module.exports.auth = auth;
module.exports.entity = entity;
